import { cva } from '@/styled-system/css';

export const menuItemMetaRecipe = cva({
  base: {
    display: 'block',
    gridArea: 'meta',
    color: { base: 'Menu.ItemMeta.text.meta.default' },
    textStyle: 'body',
  },
  variants: {
    disabled: {
      true: {},
      false: {
        color: {
          _groupHover: 'Menu.ItemMeta.text.meta.hover',
          _groupActive: 'Menu.ItemMeta.text.meta.pressed',
        },
      },
    },
  },
});
